import cn from 'classnames';
import styles from './styles.scss';
import { format } from 'utils';
import { forwardRef } from 'react';

export interface OptionProps {
  value: number | string;
  label: string;
  disabled?: boolean;
  className?: string;
}

export interface SelectInjectedProps extends OptionProps {
  labelFormat?: string;
  onClick: () => void;
  selected: boolean;
}

export const Option = forwardRef<HTMLLIElement, OptionProps>((props, ref) => {
  const { value, label, disabled, className, selected, onClick, labelFormat } =
    props as SelectInjectedProps;
  return (
    <li
      ref={ref}
      key={value}
      className={cn(
        styles.item,
        styles.option,
        {
          [styles.selected]: selected,
          [styles.disabled]: disabled
        },
        className
      )}
      onClick={onClick}
      dangerouslySetInnerHTML={{ __html: labelFormat ? format(labelFormat, label) : label }}
    />
  );
});
